import { Controller } from "@hotwired/stimulus"
import * as myMap from "./maps"
import { resolveMapTypeId } from "./maps"

export default class extends Controller {
  static values = {
    geojsonUrl: String,
    geojson: String,
    strokeColor: String,
    defaultZoom: { type: Number, default: 10 },
    defaultMapType: { type: String, default: 'roadmap' }
  }

  connect() {
    // Wait for Google Maps to be available
    if (typeof google !== 'undefined' && google.maps) {
      this.initializeMap()
    } else {
      // If Google Maps not loaded yet, wait and try again
      this.element.innerHTML = '<p class="text-muted small"><em>Loading map...</em></p>'
      setTimeout(() => this.connect(), 500)
    }
  }

  async initializeMap() {
    try {
      let geojson

      if (this.geojsonUrlValue) {
        const response = await fetch(this.geojsonUrlValue)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        geojson = await response.json()
      } else if (this.geojsonValue) {
        geojson = JSON.parse(this.geojsonValue)
        if (typeof geojson === 'string') geojson = JSON.parse(geojson)
      } else {
        this.element.innerHTML = '<p class="text-muted small"><em>No GeoJSON data available</em></p>'
        return
      }

      // Create a simple map centered on the GeoJSON
      const map = new google.maps.Map(this.element, {
        ...myMap.defaultMapOptions(53.745, -2.883333, this.defaultZoomValue, resolveMapTypeId(this.defaultMapTypeValue)),
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      })

      // Add GeoJSON data to the map
      const bounds = new google.maps.LatLngBounds()

      map.data.addGeoJson(geojson)

      // Style the features
      map.data.setStyle({
        strokeColor: this.strokeColorValue || '#0000FF',
        strokeWeight: 2,
        fillOpacity: 0.1,
        fillColor: this.strokeColorValue || '#0000FF'
      })

      // Fit bounds to the GeoJSON
      map.data.forEach((feature) => {
        feature.getGeometry().forEachLatLng((latlng) => {
          bounds.extend(latlng)
        })
      })

      if (!bounds.isEmpty()) {
        map.fitBounds(bounds)
      }
    } catch (error) {
      console.error('Error initializing layer map preview:', error)
      this.element.innerHTML = `<p class="text-muted small"><em>Unable to display map preview: ${error.message}</em></p>`
    }
  }
}
